<template>
    <div class="fillcontain">
        <div class="table_container">
            <el-row>
                <el-button type="primary" @click="handleEdit(0, '','add')">新增优惠券</el-button>
            </el-row>
            <br/>
            <el-table
                :data="tableData"
                style="width: 100%"
                v-loading="loading">
              <el-table-column label="主图">
                <template slot-scope="scope">
                  <img :src="scope.row.photo.showThumbnail" v-if="scope.row.photo != null" width="50" height="50"/>
                  <img src="../../assets/images/coupon.png" v-else width="50" height="50"/>

                </template>
              </el-table-column>
              <el-table-column
                label="券名"
                prop="name">
              </el-table-column>
              <el-table-column
                label="显示名"
                prop="displayName">
              </el-table-column>
              <el-table-column
                label="类型"
                :formatter="typeFormat">
              </el-table-column>
              <el-table-column
                label="领取时间"
                :formatter="startEndTimeFormat">
              </el-table-column>
              <el-table-column
                label="使用时间"
                :formatter="useTimeFormat">
              </el-table-column>
              <el-table-column
                label="使用范围"
                :formatter="goodsFormat">
              </el-table-column>
              <el-table-column
                label="数量"
                prop="totalCount">
              </el-table-column>
              <el-table-column
                label="券值"
                :formatter="calueFormat">
              </el-table-column>
              <el-table-column
                label="领取方式"
                :formatter="getTypeFormat">
              </el-table-column>

                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="handleEdit(scope.$index, scope.row,'edit')">
                        编辑
                    </el-button>
                    <el-button
                      v-if="scope.row.getType == 2"
                      size="mini"
                      @click="goUrls(scope.row)">
                      链接管理
                    </el-button>
                    <el-button
                      size="mini"
                      v-if="scope.row.getType == 3"
                      @click="goCodes(scope.row)">
                      兑换码管理
                    </el-button>
                    <el-button
                      v-if="scope.row.status == 1"
                      size="mini"
                      type="danger"
                      @click="handleDeleteAlert( scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pages.page"
                  :page-size="pages.pageSize"
                  layout="total, prev, pager, next"
                  :total="pages.total">
                </el-pagination>
            </div>

            <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
                <el-alert
                  v-if="coupon.id != 0"
                  title="注意：修改优惠券不会影响已经领取到账的券，只会影响修改之后再领取的"
                  type="error"
                  effect="dark">
                </el-alert>
                <el-form :model="coupon" ref="form" :rules="rules">
                    <el-form-item label="券名" label-width="120px" prop="name" required>
                        <el-input v-model="coupon.name" auto-complete="off"></el-input>
                    </el-form-item>
                  <el-form-item label="显示名" label-width="120px" prop="displayName" required>
                    <el-input v-model="coupon.displayName" auto-complete="off"></el-input>
                    <el-alert
                      title="显示在用户端的券名"
                      type="success">
                    </el-alert>
                  </el-form-item>
                  <el-form-item label="类型" label-width="120px">
                    <el-select v-model="coupon.type" placeholder="类型" style="width:100%;">
                      <el-option
                        key="1"
                        label="代金券"
                        value="1">
                      </el-option>
                      <el-option
                        key="2"
                        label="折扣券"
                        value="2">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="图片" label-width="80px">
                    <div style="text-align: left;margin: 5px">
                      <el-upload
                        :limit="picLimit"
                        :action="uploadUrl"
                        list-type="picture-card"
                        :on-preview="handlPicPreview"
                        :before-remove="handleBeforeRemove"
                        :on-success="handleSuccess"
                        :file-list="picFiles"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <div v-show="picVisible" size="tiny">
                        <img width="100%" :src="picUrl" alt="">
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="领取时间段" label-width="120px" prop="startEndTime"   required>
                    <el-date-picker

                      v-model="coupon.startEndTime"
                      type="datetimerange"
                      format="yyyy-MM-dd HH:mm"
                      value-format="yyyy-MM-dd HH:mm"
                      range-separator="至"
                      start-placeholder="可领取开始时间"
                      end-placeholder="可领取结束时间">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="有效期类型" label-width="120px">
                    <el-select v-model="coupon.expireType" placeholder="有效期类型" style="width:100%;" >
                      <el-option
                        key="1"
                        label="某时间段内有效"
                        value="1">
                      </el-option>
                      <el-option
                        key="2"
                        label="领取后天数内有效"
                        value="2">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="coupon.expireType == '2'" label="天数" label-width="120px" prop="expireValue"   required>
                    <el-input-number v-model="coupon.expireValue" auto-complete="off" :min="1"></el-input-number>
                    <el-alert
                      title="领取之后xx天内有效"
                      type="success">
                    </el-alert>
                  </el-form-item>
                  <el-form-item  v-if="coupon.expireType == '1'"  label="可使用时间段" prop="useTime"  label-width="120px" required>
                    <el-date-picker
                      v-model="coupon.useTime"
                      type="daterange"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="使用开始时间"
                      end-placeholder="使用结束时间">
                    </el-date-picker>
                    <el-alert
                      title="领取之后该时间段内有效"
                      type="success">
                    </el-alert>
                  </el-form-item>
                  <el-form-item label="总发放数量" label-width="120px" prop="totalCount" required>
                    <el-input-number v-model="coupon.totalCount" auto-complete="off" :min="0"></el-input-number>
                    <el-alert
                      title="0表示无限量发放"
                      type="success">
                    </el-alert>
                  </el-form-item>
                  <el-form-item label="每人可领取数" label-width="120px" prop="limitGetCount"  required>
                    <el-input-number v-model="coupon.limitGetCount" auto-complete="off" :min="1"></el-input-number>
                  </el-form-item>
                  <el-form-item label="门槛金额" label-width="120px" prop="minPrice"   required>
                    <el-input-number v-model="coupon.minPrice" auto-complete="off" :min="0"></el-input-number>
                    <el-alert
                      title="订单达到该金额可使用优惠券，0表示无门槛"
                      type="success">
                    </el-alert>
                  </el-form-item>
                  <el-form-item label="面额" label-width="120px" prop="cValue" required>
                    <el-input-number v-model="coupon.cValue" auto-complete="off" :min="1"></el-input-number>
                    <el-alert
                      title="当类型为‘折扣券’时，这里表示百分比，如：填写20表示折扣20%"
                      type="success">
                    </el-alert>
                  </el-form-item>
                  <el-form-item label="参与的商品" label-width="120px" >
                    <searchGoods :initGoods="coupon.useGoodsList" v-on:goods="useGoods"></searchGoods>
                    <el-alert
                      title="不选择时默认为全部商品可使用优惠券，选择时仅限选择的商品可使用优惠券"
                      type="success">
                    </el-alert>
                    <el-row>
                      <el-col :span="2" v-for="(goods,index) in coupon.useGoodsList" :key="goods.id" :offset="index > 0 ? 2 : 0">
                        <el-card :body-style="{ padding: '0px' }">
                          <img :src="goods.pics[0].showThumbnail" v-if="goods.pics != null && goods.pics.length > 0" style="width: 85px;height: 85px" class="image">
                          <div style="padding: 1px;text-align: center">
                            <span>{{goods.name}}</span>
                          </div>
                        </el-card>
                      </el-col>
                    </el-row>

                  </el-form-item>
                  <el-form-item label="不参与的商品" label-width="120px">
                    <searchGoods :initGoods="coupon.unUseGoodsList" v-on:goods="unUseGoods"></searchGoods>
                    <el-alert
                      title="不选择时默认为全部商品可使用优惠券，选择时仅限选择的商品不可使用优惠券"
                      type="success">
                    </el-alert>
                    <el-row>
                      <el-col :span="2" v-for="(goods,index) in coupon.unUseGoodsList" :key="goods.id" :offset="index > 0 ? 2 : 0">
                        <el-card :body-style="{ padding: '0px' }">
                          <img :src="goods.pics[0].showThumbnail" v-if="goods.pics != null && goods.pics.length > 0" style="width: 85px;height: 85px" class="image">
                          <div style="padding: 1px;text-align: center">
                            <span>{{goods.name}}</span>
                          </div>
                        </el-card>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item label="领取方式" label-width="120px">
                    <el-select v-model="coupon.getType" placeholder="发放方式" style="width:100%;">

                      <el-option
                        key="1"
                        label="弹框领取"
                        value="1">
                      </el-option>
                      <el-option
                        key="5"
                        label="领券中心"
                        value="5">
                      </el-option>
                      <!--<el-option
                        key="2"
                        label="链接方式领取"
                        value="2">
                      </el-option>-->
                      <el-option
                        key="3"
                        label="兑换码兑换"
                        value="3">
                      </el-option>
                      <el-option
                        key="4"
                        label="注册赠送"
                        value="4">
                      </el-option>
                    </el-select>
                    <el-alert
                      title="用户端领取：在用户端的领券中心可以看到并领取。链接方式领取：指店家直接发送一个领取链接，用户访问该链接可以领取到。兑换码：通过发放兑换码，用户可以在用户端进行输入兑换，注册赠送：新用户首次登录后会自动生在一张优惠券给该用户"
                      type="success">
                    </el-alert>
                  </el-form-item>
                  <el-form-item label="说明" label-width="120px">
                    <el-input
                      type="textarea"
                      placeholder="请输入内容"
                      maxlength="100"
                      show-word-limit
                      rows="5"
                      v-model="coupon.note" auto-complete="off"></el-input>
                  </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleSave">确 定</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
    import searchGoods from '../../components/goods/goods';
    export default {
        components: {
          searchGoods,
        },
        data(){
            return {
                picLimit:1,
                uploadUrl:window.server.baseUrl+'/common/imageUpload',
                loading:false,
                coupon:{
                    id:0,
                    name:"",
                    displayName:"",
                    type:1,
                    expireType:2,
                    expireValue:1,
                    limitGetCount:1,
                    totalCount:0,
                    minPrice:0,
                    cValue:0,
                    getType:1,
                    note:"",
                    startEndTime:"",
                    useTime:"",
                    useGoodsList:[],
                    unUseGoodsList:[],
                    photo_md5:""
                },
                dialog:{
                    dialogFormVisible:false,
                    title:"",
                    close:false,
                },
                pages:{
                    offset: 0,
                    pageSize: 30,
                    page: 1,
                    total: 0,
                },
              tableData: [],
              picFiles:[],
              picVisible:false,
              picUrl:"",
              rules:{
                name :[{required: true, message: '请输入', trigger: 'blur'}],
                displayName :[{required: true, message: '请输入', trigger: 'blur'}],
                startEndTime :[{required: true, message: '请输入', trigger: 'blur'}],
                useTime :[{required: true, message: '请输入', trigger: 'blur'}],
                minPrice :[{required: true, message: '请输入', trigger: 'blur'}],
                cValue :[{required: true, message: '请输入', trigger: 'blur'}],
                limitGetCount :[{required: true, message: '请输入', trigger: 'blur'}],
                totalCount :[{required: true, message: '请输入', trigger: 'blur'}],

              }
            }
        },
        created(){
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/store/coupons', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.tableData = res.data.coupons.content;
                    that.pages.total = res.data.coupons.totalElements;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.pages.page = val;
                this.pages.offset = (val - 1)*this.pages.pageSize;
                this.initData()
            },

          handleBeforeRemove(file, fileList){
            var that = this;
            this.$confirm('此操作将删除该图片, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              that.handleRemove(file, fileList);
            }).catch(() => {

            });
            return false;
          },
          handleRemove(file, fileList) {
            console.log(file);
            var index = this.picFiles.indexOf(file);
            console.log(index);
            if (index > -1) {
              this.picFiles.splice(index, 1);
            }
            console.log(this.picFiles)
          },
          handleSuccess(response,file, fileList) {
            file.id = response.ids[0];
            console.log(response);
            file.url = response.thumbnails[0];
            file.downloadUrl = response.data[0];
            file.md5 = response.md5s[0];
            file.ext = response.exts[0];
            this.picFiles.push(file);
          },
          handlPicPreview(file) {
            console.log(file);
            //BMP,JPG、JPEG、PNG
            if(file.ext.toLowerCase() == ".jpg" || file.ext.toLowerCase() == ".bmp" || file.ext.toLowerCase() == ".jpeg" || file.ext.toLowerCase() == ".png"){
              if(this.picUrl == file.downloadUrl){
                this.picVisible = !this.picVisible;
              }else{
                this.picVisible = true;
              }
              this.picUrl = file.downloadUrl;

            }else{
              this.picVisible = false;
              location.href = file.downloadUrl;
            }

          },

            handleEdit(index, row,action) {
              this.picFiles = new Array();
              if(action == "edit"){
                this.dialog.title = "修改优惠券";
                this.coupon.id=row.id;
                this.coupon.name=row.name;
                this.coupon.displayName=row.displayName;
                this.coupon.type=""+row.type;
                this.coupon.expireType=""+row.expireType;
                this.coupon.expireValue=row.expireValue;
                this.coupon.limitGetCount=row.limitGetCount;
                this.coupon.totalCount=row.totalCount;
                this.coupon.minPrice=row.minPrice;
                this.coupon.cValue=row.cvalue;
                this.coupon.getType=""+row.getType;
                this.coupon.note=row.note;
                var smonth = row.startTime.substr(5,2);
                if(smonth == 1){
                  smonth = 12;
                }else{
                  smonth --;
                }
                var emonth = row.endTime.substr(5,2);
                if(emonth == 1){
                  emonth = 12;
                }else{
                  emonth --;
                }
                this.coupon.startEndTime=[new Date(row.startTime.substr(0,4), smonth, row.startTime.substr(8,2), row.startTime.substr(11,2), row.startTime.substr(14,2)), new Date(row.endTime.substr(0,4), emonth, row.endTime.substr(8,2), row.endTime.substr(11,2), row.endTime.substr(14,2))];
                if(row.expireType == 1 && row.useStartTime != null){
                  var smonth = row.useStartTime.substr(5,2);
                  if(smonth == 1){
                    smonth = 12;
                  }else{
                    smonth --;
                  }
                  var emonth = row.useEndTime.substr(5,2);
                  if(emonth == 1){
                    emonth = 12;
                  }else{
                    emonth --;
                  }
                  this.coupon.useTime=[new Date(row.useStartTime.substr(0,4), smonth, row.useStartTime.substr(8,2)), new Date(row.useEndTime.substr(0,4), emonth, row.useEndTime.substr(8,2))];

               }else{
                  this.coupon.useTime="";
                }

                this.coupon.useGoodsList=row.useGoodsList;
                this.coupon.unUseGoodsList=row.unUseGoodsList;

                if(row.photo != null){//图片处理
                  var imgObj = row.photo;
                  var img = {name: imgObj.name, url: imgObj.showThumbnail,id:imgObj.id,downloadUrl:imgObj.showUrl,ext:imgObj.ext,md5:imgObj.md5}
                  this.picFiles.push(img);

                }

                console.log(this.coupon)
              }else if(action == "add"){
                this.dialog.title = "新增优惠券";
                this.coupon.id=0;
                this.coupon.name="";

                this.coupon.displayName="";
                this.coupon.type="1";
                this.coupon.expireType="2";
                this.coupon.expireValue=0;
                this.coupon.limitGetCount=1;
                this.coupon.totalCount=0;
                this.coupon.minPrice=0;
                this.coupon.cValue=0;
                this.coupon.getType="1";
                this.coupon.note="";
                this.coupon.startEndTime="";
                this.coupon.useTime="";
                this.coupon.useGoodsList=[];
                this.coupon.unUseGoodsList=[];
              }

              this.dialog.dialogFormVisible = true;
            },


            handleSave() {

              this.$refs['form'].validate((valid) => {
                if (!valid) {
                  this.$message({
                    message: "请填写必填信息",
                    type: 'warning'
                  });
                  return;
                }else{
                  this.loading = true;
                  var that = this;
                  if(that.picFiles.length > 0){
                    that.coupon.photo_md5 = this.picFiles[0].md5;
                  }
                  if(that.coupon.unUseGoodsList != null) {
                    if(that.coupon.unUseGoodsList == "[]"){
                      that.coupon.unUseGoodsList = null;
                    }else {
                      that.coupon.unUseGoodsList = JSON.stringify(that.coupon.unUseGoodsList);
                    }
                  }
                  if(that.coupon.useGoodsList != null) {
                    if(that.coupon.useGoodsList == "[]"){
                      that.coupon.useGoodsList = null;
                    }else {
                      that.coupon.useGoodsList = JSON.stringify(that.coupon.useGoodsList)
                    }
                  }
                  that.$api.post('/store/coupons', that.coupon, response => {
                    if (response.status >= 200 && response.status < 300) {
                      console.log(response.data);
                      var res = response.data;
                      if (res.code == 0) {
                        this.$message({
                          message: that.dialog.title+'成功',
                          type: 'success'
                        });
                        this.dialog.dialogFormVisible = false;
                        this.initData();
                      }else{
                        this.$message({
                          message: res.msg,
                          type: 'warning'
                        });
                      }
                    } else {
                      this.$message({
                        message: "服务器维护中",
                        type: 'error'
                      });
                    }

                  });

                  this.loading = false;
                }
              });

            },
            handleDeleteAlert(row) {
                this.$confirm('此操作将删除该优惠券标签, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleDelete(row);
                }).catch(() => {

                });
            },
          handleDelete(row) {
            this.loading = true;
            var that = this;
            that.$api.delete('/store/coupons/'+row.id, null, response => {
              if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.initData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                    this.loading = false;
                  }
              } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                this.loading = false;
              }

            });
          },
          useGoods(goods){
              console.log(goods);
              this.coupon.useGoodsList = goods;
          },
          unUseGoods(goods){
            this.coupon.unUseGoodsList = goods;
          },
          startEndTimeFormat(row){
            return row.startTime+"~"+row.endTime;
          },
          useTimeFormat(row){
              if(row.expireType == 1){
                  return row.useStartTime.substr(0,10)+"~"+row.useEndTime.substr(0,10);
              }else{
                  return "领取后"+row.expireValue+"天有效";
              }

          },
          goodsFormat(row){
            if((row.useGoodsList != null && row.useGoodsList.length > 0) || (row.unUseGoodsList != null  && row.unUseGoodsList.length > 0)){
              return '部分商品可用';
            }else{
              return "全部商品可用";
            }

          },
          typeFormat(row){
            return row.type == 1?"代金券":"折扣券";
          },
          calueFormat(row){
              var str = "";
              if(row.type == 1){
                  if(row.minPrice > 0){
                    str = "满"+row.minPrice+"元减"+row.cvalue+"元";
                  }else{
                    str = "无门槛减"+row.cvalue+"元";
                  }
              }else{
                  if(row.minPrice > 0){
                    str = "满"+row.minPrice+"元打"+row.cvalue/10+"折";
                  }else{
                    str = "无门槛打"+row.cvalue/10+"折";
                  }
              }

            return str;
          },
          getTypeFormat(row){
              if(row.getType == 1){
                return "弹框L                                                                                    领取";
              }else if(row.getType == 2){
                return "链接领取";
              }else if(row.getType == 3){
                return "兑换码兑换";
              }else if(row.getType == 4){
                return "注册赠送";
              }else if(row.getType == 5){
                return "领券中心";
              }
          },
          goUrls(row) {
            this.$router.push({
              path: '/store/coupon/urls',query:{id:row.id}
            })
          },
          goCodes(row) {
            this.$router.push({
              path: '/store/coupon/code',query:{id:row.id}
            })
          },

        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
  .div-inline{ display:inline}
</style>



// WEBPACK FOOTER //
// src/pages/store/Coupons.vue